module.exports = __webpack_public_path__ + "static/media/HelveticaNowText-Light.226a5339.otf";